module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-x-6fa22ee3.svg";